import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    getEquipmentDetails,
    deleteEquipmentDetails,
    getEquipmentList,
    getEquipmentUsed,
} from "../Actions/EquipmentManagementAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { withTranslation } from "react-i18next";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
    Equipment: "",
    EquipmentType: "",
    Category: "",
    capacity: "",
    ServiceTypes: "",
    PageNumber: 1,
    PageSize: 20,
};
class NoteDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: "",
            modalIsOpen: false,
            delete: "",
        };
    }
    componentDidMount() {
        const { match, dispatch } = this.props;
        const { params } = match;
        const { id } = params;
        dispatch(getEquipmentDetails(id));
    }
    
    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowNoteSidePan", data: false });
        this.props.history.push("/Home/Notes");
    };

    ConfirmAlert(item) {
        const { dispatch } = this.props;
        dispatch(getEquipmentUsed(item.equipmentId));
        this.setState({ modalIsOpen: true });
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state[nodeName] = e.target.value;
        this.setState({});
    }

    render() {
        const { EquipmentUsed, EquipmentDetail,t } = this.props;
        return (
            <div className="pb-3">
                <Modal
                    size="md"
                    show={this.state.modalIsOpen}
                    onHide={() => this.setState({ modalIsOpen: false, delete: "" })}
                    aria-labelledby="example-modal-sizes-title-sm"
                    backdrop="static"
                    centered="true"
                    animation="true"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-sm">
                        {t("confirmAlertMessage.DeleteMsg")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table style={{ width: "100%" }}>
                            <tr style={{ lineHeight: "30px" }}>
                                <strong>{t("content.totalship")} : </strong>
                                <span>{EquipmentUsed ? EquipmentUsed.shipCount : 0}</span>
                            </tr>
                            <tr style={{ lineHeight: "30px" }}>
                                <strong>{t("EquipmentManagementScreenContent.ShipNames")} : </strong>
                                <span>
                                    {EquipmentUsed
                                        ? EquipmentUsed.shipNames === null
                                            ? "No Ships"
                                            : EquipmentUsed.shipNames.toString()
                                        : ""}
                                </span>
                            </tr>
                            {/* <div
                                className="col-lg-6 "
                            > */}
                            <span class="text-muted">
                                <i>({t("EquipmentManagementScreenContent.DeleteNote")})</i>
                            </span>
                            <br></br>
                            <input
                                className="form-control mt-2"
                                style={{ width: "auto" }}
                                type="text"
                                name="delete"
                                placeholder="Delete"
                                onChange={(e) => this.handleInputChange(e)}
                                value={this.state.delete}
                            ></input>
                            {/* </div> */}
                            <div
                                className="form-group search-btn-col mt-4"
                                style={{ textAlign: "end" }}
                            >
                                <button
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    type="submit"
                                    onClick={() => this.deleteEquipmentDetails(EquipmentDetail)}
                                >
                                    {" "}
                                    {t("confirmAlertMessage.Ok")}{" "}
                                </button>
                                <button
                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                    type="button"
                                    // onClick={() => this.ClearInput()}
                                    onClick={() =>
                                        this.setState({ modalIsOpen: false, delete: "" })
                                    }
                                >
                                    {" "}
                                    {t("ComplianceandBudgetScreen.Cancel")}{" "}
                                </button>
                            </div>
                        </table>
                    </Modal.Body>
                </Modal>
                {this.renderCardData()}
            </div>
        );
    }

    renderCardData() {
        const { EquipmentDetail,t } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="resource-list-auth-date">
                                <div className="panel-box search-filter-box w-100">
                                    <button
                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                        onClick={() => this.hideSidePanel()}
                                    >
                                        &larr; {t("CommonText.Return")}
                                    </button>
                                    <div
                                        className="card mt-2 MM-card-header"
                                        style={{ backgroundColor: "white" }}
                                    >
                                        <div
                                            className="card-body"
                                            style={{
                                                padding: "0rem",
                                                backgroundColor: "#1a3464",
                                                color: "white",
                                            }}
                                        >
                                            <h5
                                                className="card-title ml-2 mt-2"
                                                style={{ color: "092a51" }}
                                            >
                                               {t("ShipDetailsScreen.EquipmentDetails")}
                                            </h5>
                                        </div>
                                        <div className="pt-3 pb-3 search-filter-box">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label">{t("EquipmentManagementScreenContent.Name")} : </label>
                                                    <span>
                                                        {" "}
                                                        {EquipmentDetail
                                                            ? EquipmentDetail.equipmentName
                                                            : ""}
                                                    </span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label">{t("ComplianceandBudgetScreen.Type")} : </label>
                                                    <span>
                                                        {" "}
                                                        {EquipmentDetail
                                                            ? EquipmentDetail.equipmentType
                                                            : ""}
                                                    </span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label">{t("TopPaneContent.Category")} : </label>
                                                    <span>
                                                        {" "}
                                                        {EquipmentDetail ? EquipmentDetail.category : ""}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label">{t("content.Servicetype")} : </label>
                                                    <span>
                                                        {" "}
                                                        {EquipmentDetail
                                                            ? EquipmentDetail.serviceType.toString()
                                                            : ""}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label">
                                                    {t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")} :{" "}
                                                    </label>
                                                    <span>
                                                        {" "}
                                                        {EquipmentDetail ? EquipmentDetail.capacity : ""}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 pb-2 pt-2">
                                            <div
                                                className="search-btn-col mt-1"
                                                style={{ textAlign: "right" }}
                                            >
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() =>
                                                        this.EditEquipmentDetails(EquipmentDetail)
                                                    }
                                                >
                                                    {" "}
                                                    {t("IntervelScreen.Edit")}{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button"
                                                    onClick={() => this.ConfirmAlert(EquipmentDetail)}
                                                >
                                                    {" "}
                                                    {t("CommonText.Delete")}{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    EditEquipmentDetails(item) {
        this.props.history.push(`/Home/EditNote/${1}`);
        this.props.dispatch({ type: "AttchmentUploaded", data: "" });
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }
    deleteEquipmentDetails(item) {
        const { dispatch ,t} = this.props;
        if (this.state.delete === "") {
            // swal("Error!", 'Please type "Delete" to continue', "warning");
            swal({
                title: t('SwalError.ErrorTitle'), 
                text: t('SwalError.DeleteKeywordMessage'),  
                icon: 'warning',  
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
        } else if (this.state.delete === "Delete") {
            let equipment = {
                equipmentId: item.equipmentId,
                category: item.category,
                equipmentName: item.equipmentName,
                equipmentType: item.equipmentType,
                annually: false,
                biannually: false,
                fiveYearly: false,
                tenYearly: false,
                isDeleted: true,
                modifiedBy: currentuser.name,
                confirmDelete: this.state.delete,
            };
            item.serviceType.map((x) => {
                if (x.toLowerCase() === "annually") {
                    equipment.annually = true;
                }
                if (x.toLowerCase() === "biannually") {
                    equipment.biannually = true;
                }
                if (x.toLowerCase() === "fiveyearly") {
                    equipment.fiveYearly = true;
                }
                if (x.toLowerCase() === "tenyearly") {
                    equipment.tenYearly = true;
                }
            });
            let url = `${API.postEquipment}`;
            axios
                .put(url, equipment)
                .then((response) => {
                    dispatch(getEquipmentList(searchData));
                    this.hideSidePanel();
                    toast.success(t('confirmAlertMessage.DeletedSuccessMessage'), {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch({
                        type: "deleteEquipmentDetailSuccess",
                        data: response.data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: "deleteEquipmentDetailFailure",
                        error: "ERROR",
                    });
                });
        } else {
            // swal(
            //     "Error!",
            //     'Please type correct keyword "Delete" to continue',
            //     "warning"
            // );
            swal({
                title: t('SwalError.ErrorTitle'), 
                text: t('SwalError.DeleteKeywordMessage'),  
                icon: 'warning',  
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
        }
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
function mapStateToProps(state) {
    return {
        EquipmentDetail: state.MasterScreenReducer.EquipmentDetail,
        EquipmentUsed: state.MasterScreenReducer.EquipmentUsed,
    };
}
export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(NoteDetails))
);
